import { type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';
import { inMemoryCache } from '../../../utils/caching/in-memory';

const GQL_ASSETS_OBJECT_TYPES_NAME = 'SearchPageAssetsObjectTypesQuery';
const assetsObjectTypesQueryString = `query ${GQL_ASSETS_OBJECT_TYPES_NAME}(
	$objectTypeARIs: [ID!]!) {
		assets_objectTypesByIds(ids: $objectTypeARIs) {
    		id
    		name
    		sequentialId @optIn(to: "AssetsApFields")
    		icon {
      			url16
    		}
    		schema {
      			name
    		}
  		}
	}`;

export const assetsObjectTypesCache: {
	get: (key: string) => Promise<AggResponse<AssetsObjectTypesResponse>> | undefined;
	set: (key: string, result: Promise<AggResponse<AssetsObjectTypesResponse>>) => void;
	has: (key: string) => boolean;
	clear: (key?: string) => void;
	inMemoryDecorator: (
		key: string,
		supplier: () => Promise<AggResponse<AssetsObjectTypesResponse>>,
		expireWhen?: ((result: AggResponse<AssetsObjectTypesResponse>) => boolean) | undefined,
	) => Promise<AggResponse<AssetsObjectTypesResponse>>;
} = inMemoryCache<AggResponse<AssetsObjectTypesResponse>>();

export type AssetsObjectTypesQueryVariables = {
	objectTypeARIs: string[];
};

export type AssetsObjectTypesResponse = {
	assets_objectTypesByIds: {
		id: string;
		name: string;
		sequentialId: string;
		icon: {
			url16: string;
		};
		schema: {
			name: string;
		};
	}[];
};

export const assetsObjectTypesQuery: (
	objectTypeARIs: string[],
) => Promise<AggResponse<AssetsObjectTypesResponse>> = async (objectTypeARIs: string[]) => {
	return assetsObjectTypesCache.inMemoryDecorator(`${objectTypeARIs}`, async () => {
		const response = await fetchAgg<AssetsObjectTypesQueryVariables, AssetsObjectTypesResponse>({
			graphQuery: assetsObjectTypesQueryString,
			variables: {
				objectTypeARIs,
			},
			operationName: GQL_ASSETS_OBJECT_TYPES_NAME,
			headers: {
				'X-ExperimentalApi': 'AssetsObjectTypes',
			},
		});

		const hasErrors = response.errors?.some((error) => error);

		if (hasErrors) {
			return Promise.reject(response);
		}

		return response;
	});
};
